import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-campaign-builder',
  templateUrl: './theme-campaign-builder.component.html',
  styleUrls: ['./theme-campaign-builder.component.css']
})
export class ThemeCampaignBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
